// This file is generated by a script and should not be modified directly.
const markdown: string =
  "RNCP code of the research scope\n\nThe RNCP corresponds to the National Directory of Professional Certifications by [France Compétences](https://www.francecompetences.fr/reguler-le-marche/certification-professionnelle/)\n"
export default markdown
